import { create } from "zustand";
import { persist } from "zustand/middleware";
import axiosInstance from "../services/axiosInstance";
import { getActiveQuestions } from "../services/questionBank.api";

const useQuestionStore = create(
  persist(
    (set) => ({
      questions: [],
      loading: false,
      error: null,

      selectedCourseId: "",
      setSelectedCourseId: (courseId) => set({ selectedCourseId: courseId || "" }),

      async fetchAllQuestions(params = {}) {
        set({ loading: true, error: null });
        try {
          const rawCourseId = params?.courseId ?? params?.course ?? "";
          const courseId = rawCourseId ? String(rawCourseId) : "";

          const url = courseId
            ? `/questions/course/?courseId=${encodeURIComponent(courseId)}`
            : "/questions";

          const response = await axiosInstance.get(url);
          const data = response?.data?.data || response?.data || [];
          set({ questions: Array.isArray(data) ? data : [], loading: false });
          return data;
        } catch (err) {
          const message =
            err?.response?.data?.message || err?.message || 'Failed to load questions';
          set({ error: message, loading: false });
          throw err;
        }
      },

      async deleteQuestion(questionId, opts = {}) {
        const { soft = true } = opts;
        set({ loading: true, error: null });
        try {
          await axiosInstance.delete(
            `/api/questions/${encodeURIComponent(questionId)}?soft=${soft ? "true" : "false"}`
          );
          set({ loading: false });
          return true;
        } catch (err) {
          const message =
            err?.response?.data?.message || err?.message || 'Failed to delete question';
          set({ error: message, loading: false });
          throw err;
        }
      },

      async fetchActiveQuestions() {
        set({ loading: true, error: null });
        try {
          const data = await getActiveQuestions();
          set({ questions: Array.isArray(data) ? data : [], loading: false });
          return data;
        } catch (err) {
          const message =
            err?.response?.data?.message || err?.message || 'Failed to load questions';
          set({ error: message, loading: false });
          throw err;
        }
      },
    }),
    {
      name: "question-store",
      partialize: (state) => ({ selectedCourseId: state.selectedCourseId }),
    }
  )
);

export default useQuestionStore;
